module.exports = __webpack_public_path__ + "static/media/rose.46fb1a0f.png";